export default __webpack_public_path__ + "static/1261-71ba4f3734cf3e3631a9bde0028f14d4.gif";